import { closestCenter, DndContext } from '@dnd-kit/core'
import type React from 'react'
import type { ReactElement } from 'react'

export const DndContextWrapper: React.FC<{
  children: ReactElement
  isEditMode: boolean
}> = ({ isEditMode, children }) => {
  if (!isEditMode) {
    return <>{children}</>
  }

  return <DndContext collisionDetection={closestCenter}>{children}</DndContext>
}
